import customAxios from './axios';
import CONFIG from '../../config';

export const getAll = () => {
    return customAxios.get(CONFIG.apiURL + '/Processes').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getIndividual = (id) => {
    return customAxios.get(CONFIG.apiURL + `/Processes/${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const create = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Processes/Create', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const update = (payload) => {
    return customAxios.put(CONFIG.apiURL + '/Processes/Update', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const globalSearch = (query) => {
    return customAxios.get(CONFIG.apiURL + `/GlobalSerach/Process?searchData=${query}`).then(res => {
        let response = res['data'];
        return response;
    });
};